import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = async () => {
    const newLang = i18n.language === 'tr' ? 'en' : 'tr';
    await i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-2 rounded-lg hover:bg-gray-100 transition-colors"
      title={i18n.language === 'tr' ? 'Switch to English' : 'Türkçe\'ye geç'}
    >
      <Globe size={18} />
      <span className="font-medium">{i18n.language === 'tr' ? 'EN' : 'TR'}</span>
    </button>
  );
};
